/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {toAbsoluteUrl} from 'src/marketConnect/helpers'
import SenjaReviewsCarousel from './SenjaReviewsCarousel'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100 min-vh-100'>
      {/* begin::Body */}
      <div
        className='d-flex flex-column flex-lg-row-fluid w-lg-50 order-2 order-lg-2 h-100 min-vh-lg-100'
        style={{scrollbarWidth: 'none'}}
      >
        <div className='flex-grow-1 d-flex flex-center flex-column py-4'>
          <div className='w-lg-500px w-md-400px w-300px px-10'>
            <Outlet />
          </div>
        </div>

        <div className='flex-shrink-0 d-flex justify-content-center fw-semibold text-primary fs-base mb-2'>
          <a href='https://constacloud.com/commercium/terms-of-use.html' className='px-5' target='_blank' rel="noreferrer">
            Terms
          </a>

          <a href='https://constacloud.com/commercium/privacy-policy.html' className='px-5' target='_blank' rel="noreferrer">
            Policy
          </a>

          <a href='https://constacloud.com/commercium/contact-us.html' className='px-sm-5 px-2' target='_blank' rel="noreferrer">
            Contact us
          </a>
        </div>
      </div>
      {/* end::Body */}

      {/* begin::Aside */}
      <div
        className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-1 h-100 min-vh-lg-100'
        style={{
          backgroundImage: `url(${toAbsoluteUrl('/media/misc/auth-bg.png')})`,
        }}
      >
        <div className='d-flex flex-column h-100 w-100 px-5 px-md-15'>
          <div className='flex-grow-1 d-flex align-items-center justify-content-center'>
            <a href='https://constacloud.com/commercium/' target='_blank' rel='noopener noreferrer'>
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/logos/commercium-logo-light.png')}
                className='h-sm-85px h-50px'
              />
            </a>
          </div>

          <div className='flex-shrink-0 d-flex justify-content-center w-100'>
            <SenjaReviewsCarousel />
          </div>

          <div className='flex-grow-1' aria-hidden='true' />

          <div className='flex-shrink-0 d-flex justify-content-center text-center mb-2'>
            <div className='text-white'>
              <span className='text-white fw-semibold me-1 fw-bold'>
                {new Date().getFullYear().toString()}{' '}&copy;
              </span>
              <a href='https://constacloud.com/' target='_blank' className='text-white fw-bold' rel="noreferrer">
                ConstaCloud Private Limited
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* end::Aside */}
    </div>
  )
}

export {AuthLayout}
